import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { pageTitle } from "@/components/document-title";
import { SessionsPage } from "@/features/charging-sessions/pages/sessions-page";
import { sessionsFilterSchema } from "@/features/charging-sessions/schemas/sessions-filter-schema";

export const Route = createFileRoute(
	"/_authenticated/admin/charging/sessions/"
)({
	head: () => pageTitle("Charging Sessions"),
	component: SessionsPage,
	validateSearch: zodValidator(sessionsFilterSchema),
});
